import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmDialogComponent } from 'src/app/shared/global/confirm-dialog/confirm-dialog.component';
import { MessageDialogComponent } from '../../shared/global/message-dialog/message-dialog.component';
import { AppDirection } from '../types/app-direction.type';
import { LoadingDialogComponent } from './../../shared/global/loading-dialog/loading-dialog.component';

//#region models
export interface confirmDialogConfig {
  content?: string;
  title?: string;
  isWarning?: boolean;
  isConfirmDelete?: boolean;
  position?: any;
  confirmBtnColor?: string;
  confirmByWritingText?: boolean;
  wordBreak?: boolean;
  contentToInnerHtml?: boolean;
  isShowCheckBox?: boolean;
  checkBoxLabel?: string;
  isShowChip?: boolean;
}
export interface SnackBarConfig {
  message?: string;
  action?: any;
  duration?: any;
  verticalPosition?: any;
  horizontalPosition?: any;
  classList?: any;
}

export enum DialogStatus {
  info = 1,
  success,
  error,
  warning,
  login,
  register,
  copyableText,
}

export interface DialogConfig {
  title?: string;
  message?: any;
  status?: DialogStatus;
  duration?: number;
  redirectToLogin?: boolean;
}
export interface modalConfig {
  component?: any;
  data?: any;
  width?: any;
  minHeight?: any;
  maxWidth?: any;
  class?: any;
  height?: any;
}

//#endregion

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    protected translate: TranslateService
  ) {}

  confirmDialog(config: confirmDialogConfig) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = { ...config };

    let dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);

    return dialogRef;
  }

  openSnackBarDialog(config?: SnackBarConfig, needToTranslate: boolean = true) {
    if (needToTranslate) {
      if (config.message)
        config.message = this.translate.instant(config?.message);
      if (config.action) config.action = this.translate.instant(config?.action);
    }

    this._snackBar.open(config?.message, config?.action || '×', {
      duration: config?.duration || 2000,
      panelClass: config?.classList,
      verticalPosition: config?.verticalPosition || 'top',
      horizontalPosition: config?.horizontalPosition || 'center',
    });
  }

  openModal(config: modalConfig) {
    const dialogConfig = new MatDialogConfig();

    const dir = document.getElementsByTagName('html')[0].getAttribute('dir');

    dialogConfig.direction = dir as AppDirection;
    dialogConfig.disableClose = true;
    dialogConfig.width = config?.width;
    dialogConfig.minHeight = config?.minHeight;
    dialogConfig.maxWidth = config?.maxWidth;
    dialogConfig.height = config?.height;
    dialogConfig.panelClass = config?.class;
    dialogConfig.autoFocus = true;
    dialogConfig.data = config?.data;

    const scrollHeight = document.getElementsByTagName('html')[0].scrollHeight;
    const clientHeight = document.getElementsByTagName('html')[0].clientHeight;

    if (scrollHeight > clientHeight)
      document
        .getElementsByTagName('html')[0]
        .classList.add('cdk-global-scroll-y');

    let dialogRef = this.dialog.open(config?.component, dialogConfig);
    dialogRef.afterClosed().pipe();
    return dialogRef;
  }

  openDialog(config: DialogConfig) {
    //default value
    if (!config.status || config.status == undefined)
      config.status = DialogStatus.info;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = config;
    this.dialog.open(MessageDialogComponent, dialogConfig);
  }

  loadingDialog(message: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      message: message,
    };
    this.dialog.open(LoadingDialogComponent, dialogConfig);
  }
}
